module.exports = __webpack_public_path__ + "img/quirkysoulcollege-icon.1205b306.svg";